import { useContext } from 'react';
import { usePermissions } from '../contexts/PermissionContext';

export const usePermission = () => {
    const { permissions, hasPermission, hasModuleAccess } = usePermissions();

    const checkPermission = (moduleName, actionName) => {
        if (!permissions || Object.keys(permissions).length === 0) {
            console.log('🔍 [usePermission] No permissions loaded yet');
            return false;
        }

        // Check if user has the specific permission
        const hasPermissionResult = hasPermission(moduleName, actionName);
        
        console.log(`🔍 [usePermission] Checking ${moduleName}.${actionName}: ${hasPermissionResult}`);
        console.log(`🔍 [usePermission] Available modules:`, Object.keys(permissions));
        if (permissions[moduleName]) {
            console.log(`🔍 [usePermission] Available actions for ${moduleName}:`, Object.keys(permissions[moduleName]));
        }
        
        return hasPermissionResult;
    };

    const checkModuleAccess = (moduleName) => {
        if (!permissions || Object.keys(permissions).length === 0) {
            return false;
        }

        // Check if user has any permission for the module
        const hasModuleAccessResult = hasModuleAccess(moduleName);
        
        console.log(`🔍 [usePermission] Checking module access for ${moduleName}: ${hasModuleAccessResult}`);
        
        return hasModuleAccessResult;
    };

    return {
        checkPermission,
        checkModuleAccess,
        permissions
    };
}; 